import { SentIcon } from '@hugeicons/core-free-icons';
import { useSendMessage } from '@queries/conversations';
import {
  IconButton,
  TextInput,
  useAuthStore,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React, { useState } from 'react';
import { KeyboardAvoidingView, Platform, StyleSheet } from 'react-native';

type Props = {
  conversationId: string;
};

export default function SendMessage({ conversationId }: Props) {
  const styles = useDynamicStyles(createStyles);
  const [message, setMessage] = useState('');
  const { currentUserId } = useAuthStore();
  const { mutate: sendMessage, isPending } = useSendMessage();

  const handleSend = async () => {
    if (message.length === 0 || !currentUserId) return;

    sendMessage(
      {
        conversationId,
        user_id: currentUserId,
        content: message,
      },
      {
        onSuccess: () => {
          setMessage('');
        },
      },
    );
  };

  return (
    <KeyboardAvoidingView
      style={styles.inputContainer}
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      keyboardVerticalOffset={110}
    >
      <TextInput
        style={styles.input}
        contentStyle={styles.inputContent}
        label="Message..."
        showLabel={false}
        value={message}
        onChange={setMessage}
        multiline
        dense={true}
      />
      <IconButton
        icon={SentIcon}
        onPress={() => {
          void handleSend();
        }}
        size="medium"
        loading={isPending}
      />
    </KeyboardAvoidingView>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    inputContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      paddingRight: isMobile ? 12 : 0,
    },
    input: {
      flexGrow: 1,
      flexShrink: 1,
    },
    inputContent: {
      paddingTop: 4,
      paddingBottom: 0,
      marginVertical: 6,
      maxHeight: 60,
    },
  });
